'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck } from '@subframe/core';
import { Badge, Button, Checkbox, Loader } from '@/shared/components/ui';
import type { UseNegociacaoSelfReturn } from '../hooks';
import { WizardProgressHeader } from './WizardProgressHeader';
interface PagamentoScreenProps {
  vm: UseNegociacaoSelfReturn;
}
interface PlanoColunaProps {
  nome: string;
  preco: string;
  cobrancaLabel: string;
  recursos: string[];
  selecionado: boolean;
  recomendado?: boolean;
  onSelecionar: () => void;
  onSeguir: () => void;
  seguirDisabled: boolean;
  selecaoBloqueada: boolean;
}
const PlanoColuna = t0 => {
  const $ = _c(30);
  const {
    nome,
    preco,
    cobrancaLabel,
    recursos,
    selecionado,
    recomendado: t1,
    onSelecionar,
    onSeguir,
    seguirDisabled,
    selecaoBloqueada
  } = t0;
  const recomendado = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onSelecionar || $[1] !== selecaoBloqueada) {
    t2 = () => {
      if (selecaoBloqueada) {
        return;
      }
      onSelecionar();
    };
    $[0] = onSelecionar;
    $[1] = selecaoBloqueada;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex w-full max-w-[440px] flex-1 basis-[320px] flex-col rounded-[16px] border-2 border-solid p-6 text-left transition-all sm:basis-[380px] sm:p-8 ${selecaoBloqueada ? "cursor-not-allowed" : "cursor-pointer hover:shadow-md"} ${selecionado ? "border-brand-600" : "border-neutral-200"} ${recomendado ? "bg-brand-50" : "bg-white"}`;
  let t4;
  if ($[3] !== nome || $[4] !== recomendado) {
    t4 = recomendado ? <div className="flex items-center gap-2"><Badge variant="brand">Mais popular</Badge><Badge variant="neutral">{nome}</Badge></div> : <Badge variant="neutral" className="self-start">{nome}</Badge>;
    $[3] = nome;
    $[4] = recomendado;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-label-muted text-[15px] font-medium">/mês</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== preco) {
    t6 = <div className="text-heading-dark mt-3 text-[28px] font-bold">{preco}{t5}</div>;
    $[7] = preco;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== cobrancaLabel) {
    t7 = <span className="text-[13px] text-neutral-500">{cobrancaLabel}</span>;
    $[9] = cobrancaLabel;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== recursos) {
    t8 = recursos.map(_temp);
    $[11] = recursos;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="mt-5 flex flex-col gap-2">{t8}</div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = recomendado ? "brand-primary" : "neutral-secondary";
  let t11;
  if ($[15] !== onSeguir) {
    t11 = event => {
      event.stopPropagation();
      onSeguir();
    };
    $[15] = onSeguir;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== seguirDisabled || $[18] !== t10 || $[19] !== t11) {
    t12 = <Button size="small" className="mt-6 w-full" variant={t10} disabled={seguirDisabled} onClick={t11}>Seguir para o pagamento</Button>;
    $[17] = seguirDisabled;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== selecaoBloqueada || $[22] !== t12 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t6 || $[27] !== t7 || $[28] !== t9) {
    t13 = <button type="button" aria-disabled={selecaoBloqueada} onClick={t2} className={t3}>{t4}{t6}{t7}{t9}{t12}</button>;
    $[21] = selecaoBloqueada;
    $[22] = t12;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t6;
    $[27] = t7;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export const PagamentoScreen = t0 => {
  const $ = _c(28);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm.wizardSteps) {
    t1 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[0] = vm.wizardSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-8 flex w-full max-w-[1280px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[32px]">Qual plano faz mais sentido para você?</h1><p className="text-label-muted text-base">Compare os planos e escolha o melhor se encaixe no seu momento.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== vm.planosError || $[4] !== vm.recarregarPlanos) {
    t3 = vm.planosError && <div className="flex flex-col items-center gap-3 py-8 text-center"><span className="text-label-muted text-sm">{vm.planosError}</span><Button size="small" variant="neutral-secondary" onClick={vm.recarregarPlanos}>Tentar novamente</Button></div>;
    $[3] = vm.planosError;
    $[4] = vm.recarregarPlanos;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== vm.carregandoPlanos) {
    t4 = vm.carregandoPlanos && <div className="flex w-full max-w-[1280px] items-center justify-center gap-3 py-8"><Loader size="medium" /><span className="text-label-muted text-sm">Carregando os planos...</span></div>;
    $[6] = vm.carregandoPlanos;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== vm) {
    t5 = vm.planosCards.map(plano => <PlanoColuna key={plano.variationId} nome={plano.nome} preco={plano.preco} cobrancaLabel={"Cobran\xE7a mensal recorrente"} recursos={plano.recursos} selecionado={vm.variationId === plano.variationId} recomendado={plano.recomendado} onSelecionar={() => vm.definirPlano(plano.variationId)} onSeguir={() => vm.seguirPagamento(plano.variationId)} seguirDisabled={!vm.termosAceitos || vm.iniciandoPagamento} selecaoBloqueada={vm.iniciandoPagamento} />);
    $[8] = vm;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="flex w-full max-w-[1280px] flex-wrap justify-center gap-8">{t5}</div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== vm.alternarTermos || $[13] !== vm.termosAceitos) {
    t7 = <Checkbox checked={vm.termosAceitos} onCheckedChange={vm.alternarTermos} label={"Ao avan\xE7ar, confirmo que li e aceito os Termos de Uso e a Pol\xEDtica de Privacidade"} />;
    $[12] = vm.alternarTermos;
    $[13] = vm.termosAceitos;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== vm) {
    t8 = <button type="button" onClick={() => vm.goTo("terms")} className="text-brand-600 text-xs underline">Ler os termos</button>;
    $[15] = vm;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="mt-6 flex flex-col items-center gap-1">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t6 || $[23] !== t9) {
    t10 = <div className="flex flex-1 flex-col items-center px-6 py-10 md:px-20 md:py-16">{t2}{t3}{t4}{t6}{t9}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t1 || $[26] !== t10) {
    t11 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t10}</div>;
    $[25] = t1;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
function _temp(recurso) {
  return <div key={recurso} className="flex items-center gap-2 text-[13px] text-neutral-700"><FeatherCheck className="text-success-700 h-3.5 w-3.5 flex-none" />{recurso}</div>;
}